// What the plugin counts from the other services, as pure transitions over
// their states: the sync's completion and a review's opening. Each returns
// the next memory, and the event to send when the state crossed the line.
import type { SyncState } from '@chess/api-sync';
import type { ReviewState } from '@chess/api-review';

export interface SyncMemory {
  done: boolean;
}

/** `sync_completed` once per completion: when the phase goes from anything else to `done`. */
export function syncStep(memory: SyncMemory, state: SyncState): { memory: SyncMemory; event?: { imported: number } } {
  const done = state.phase === 'done';
  const event = done && !memory.done ? { imported: state.imported ?? 0 } : undefined;
  return { memory: { done }, event };
}

export interface ReviewMemory {
  ready: boolean;
  gameId?: string;
}

/** `review_opened` once per game: when the status reaches `ready`, or stays ready for another game. */
export function reviewStep(memory: ReviewMemory, state: Pick<ReviewState, 'status' | 'gameId'>): { memory: ReviewMemory; opened: boolean } {
  const ready = state.status === 'ready' && !!state.gameId;
  const opened = ready && (!memory.ready || state.gameId !== memory.gameId);
  return { memory: { ready, gameId: ready ? state.gameId : undefined }, opened };
}
